import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-94464140"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "comment-box" };
const _hoisted_2 = ["disabled"];
import { ref, watch } from "vue";
// Define emits for the component
export default /*#__PURE__*/ _defineComponent({
    __name: 'CommentBox',
    emits: ["update:comment"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        // Reactive property to store the comment text
        const comment = ref("");
        // Watch for changes to the comment and emit the updated value
        watch(comment, (newComment) => {
            emit("update:comment", newComment); // Emit the comment value to the parent component
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("textarea", {
                    id: "comment",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((comment).value = $event)),
                    disabled: _ctx.disabled,
                    placeholder: "Comments",
                    rows: "2",
                    cols: "50"
                }, null, 8, _hoisted_2), [
                    [_vModelText, comment.value]
                ])
            ]));
        };
    }
});
